<template>
    <ul :class="[$style['mds-list-group'], classObject, sizeClass]" :data-mds-version="version">
        <slot></slot>
    </ul>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsListGroup',
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            hasCollapsibleChild: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, applies the collapsible styling to child.',
                },
            },
            noRules: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, applies the no-rules styling.',
                },
            },
            onDark: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, changes component to on-dark styling.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`, `touch`.',
                    description: 'Sets the size of the list group.',
                },
            },
            spacious: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, applies the spacious styling.',
                },
            },
            withIcon: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description:
                        'If `true`, creates space in list group items for an icon. Icons can only be used on the top level items. When one item has an icon, all items must have an icon.',
                },
            },
        },
        provide() {
            // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
            const parentVariation = {};
            Object.defineProperty(parentVariation, 'size', {
                enumerable: true,
                get: () => this.size,
            });
            return { parentVariation };
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-list-group--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-list-group--with-icon']] = this.withIcon;
                obj[this.$style['mds-component--on-dark']] = this.onDark;
                obj[this.$style['mds-list-group--spacious']] = this.spacious;
                obj[this.$style['mds-list-group--no-rules']] = this.noRules;
                obj[this.$style['mds-list-group--has-collapsible-child']] = this.hasCollapsibleChild;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @use './list-group.scss';
</style>
